// extracted by mini-css-extract-plugin
export default {"cls1":"DSeSMDAVKEDb17X1pW5A","cls2":"XDYgaSXpp4l9OYxLNTbR DSeSMDAVKEDb17X1pW5A"};